import { config } from '@/pageConfig/termsOfService/us/en';
import { TermsOfServicePageTemplate } from '@/pageTemplate/TermsOfServicePageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

export default function LegalStuffPage() {
  const { trackEvent } = useAnalyticsContext();
  const { asPath } = useRouter();
  const hideHeader = useMemo(() => asPath.includes('show_header=false'), [asPath]);
  const hideFooter = useMemo(() => asPath.includes('show_footer=false'), [asPath]);

  useEffect(() => {
    trackEvent('terms_of_service_page.viewed');
  }, []);

  return <TermsOfServicePageTemplate config={config} showHeader={!hideHeader} showFooter={!hideFooter} />;
}
